import {ShareholderStatus} from "@/dto/company/ShareholderDTO";

export default class CreateShareholderRequest {
    public companyId: number | null = null;

    public firstName: string | null = null;

    public lastName: string | null = null;

    public ssn: string | null = null;

    public personId: number | null = null;

    public status: ShareholderStatus | null = null;

    public startDate: string | null = null;

    public endDate: string | null = null;

    public share: number | null = null;
}